// SettingsPanel.jsx - Settings panel component with Google Drive integration
import React, { useState } from 'react';
import './SettingsPanel.css';
import googleDriveService from '../services/googleDriveService';

function SettingsPanel({ onClose }) {
  const [isDriveConnected, setIsDriveConnected] = useState(
    googleDriveService.isAuthenticated()
  );
  const [isInitializing, setIsInitializing] = useState(false);

  const handleConnectDrive = () => {
    googleDriveService.initiateAuth();
  };

  const handleDisconnectDrive = () => {
    if (window.confirm('Disconnect Google Drive? You will need to reconnect to use cloud features.')) {
      googleDriveService.logout();
      setIsDriveConnected(false);
    }
  };

  const handleInitializeWorkspace = async () => {
    setIsInitializing(true);
    try {
      await googleDriveService.initializeBabaWorkspace();
      alert('Baba_Workspace folder structure created successfully!');
    } catch (error) {
      alert(`Failed to initialize workspace: ${error.message}`);
    } finally {
      setIsInitializing(false);
    }
  };

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h2>Settings</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="settings-content">
          {/* Google Drive Section - NEW */}
          <div className="settings-section">
            <h3>Google Drive</h3>
            <div className="setting-item">
              {isDriveConnected ? (
                <>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '1rem',
                    marginBottom: '0.75rem'
                  }}>
                    <span style={{ color: '#4CAF50', fontWeight: '600' }}>
                      ✓ Connected
                    </span>
                    <button 
                      className="secondary-btn"
                      onClick={handleDisconnectDrive}
                      style={{
                        padding: '0.4rem 0.8rem',
                        fontSize: '0.85rem',
                        background: 'transparent',
                        border: '1px solid #666',
                        color: '#aaa',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Disconnect
                    </button>
                  </div>
                  <button
                    onClick={handleInitializeWorkspace}
                    disabled={isInitializing}
                    style={{
                      padding: '0.5rem 1rem',
                      background: '#2563eb',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: isInitializing ? 'not-allowed' : 'pointer',
                      opacity: isInitializing ? 0.7 : 1
                    }}
                  >
                    {isInitializing ? 'Initializing...' : 'Initialize Baba_Workspace'}
                  </button>
                  <small>Creates folder structure in your Google Drive</small>
                </>
              ) : (
                <>
                  <button
                    onClick={handleConnectDrive}
                    style={{
                      padding: '0.75rem 1.5rem',
                      background: '#4285f4',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    <span>🔗</span> Connect Google Drive
                  </button>
                  <small>Required for auto-archive and seamless windows</small>
                </>
              )}
            </div>
          </div>

          <div className="settings-section">
            <h3>API Configuration</h3>
            <div className="setting-item">
              <label>Together AI API Key</label>
              <input 
                type="password" 
                placeholder="Configured in aiService.js"
                disabled
              />
              <small>Edit in: src/services/aiService.js</small>
            </div>
            <div className="setting-item">
              <label>Alpha Vantage API Key</label>
              <input 
                type="password" 
                placeholder="Configured in alphaVantageService.js"
                disabled
              />
              <small>Edit in: src/services/alphaVantageService.js</small>
            </div>
            <div className="setting-item">
              <label>Brave Search API Key</label>
              <input 
                type="password" 
                placeholder="Configured in braveSearchService.js"
                disabled
              />
              <small>Edit in: src/services/braveSearchService.js</small>
            </div>
          </div>

          <div className="settings-section">
            <h3>Features</h3>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Automatic Price Lookup
              </label>
              <small>AI automatically fetches crypto/stock prices when detected</small>
            </div>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Automatic Web Search
              </label>
              <small>AI automatically searches the web when needed</small>
            </div>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Code Syntax Highlighting
              </label>
              <small>Automatically highlights code blocks in responses</small>
            </div>
          </div>

          <div className="settings-section">
            <h3>About</h3>
            <div className="about-info">
              <p><strong>Baba AI</strong></p>
              <p>Version: 1.1.0</p>
              <p>AI Model: Meta-Llama-3.1-405B-Instruct-Turbo</p>
              <p>Provider: Together AI</p>
            </div>
          </div>

          <div className="settings-section">
            <h3>Data Management</h3>
            <div className="setting-item">
              <button 
                className="danger-btn"
                onClick={() => {
                  if (window.confirm('Delete all chats? This cannot be undone.')) {
                    localStorage.removeItem('baba-ai-chats');
                    window.location.reload();
                  }
                }}
              >
                Clear All Chats
              </button>
              <small>This will permanently delete all your chat history</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPanel;
